import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import * as $ from 'jquery';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(

  ) {
    // Place any code in here.
    $(function () {
      'use strict';

      /** navbar reference **/
      var $navbar = $(".main-nav"),
        stickyPoint = 90;

      /** Perspective mockups reference **/
      var $perspectiveMockups = $(".perspective-mockups");

      // This element is used as reference for relocation of the mockups on mobile devices.
      // If you remove it please be sure you add another reference element preferably within the same section and/or position the button was.
      // You can change the selector (".learn-more") to one that uniquely identifies the reference element.
      var $topReference = $(".learn-more", ".lightweight-template");

      var setMockupsTop = function () {
        // check if the perspective mockups elements are on the page, if you're not going to use them, you can remove all its references
        if (!$perspectiveMockups.length) return;

        if ($(window).outerWidth() < 768) {
          $perspectiveMockups.css({ top: $topReference.offset().top + "px" });
          return;
        }

        $perspectiveMockups.removeAttr("style");
      };

      var navbarSticky = function () {
        if ($(window).scrollTop() >= stickyPoint) {
          $navbar.addClass("navbar-sticky");
        } else {
          //$navbar.removeClass("navbar-sticky");
        }
      };

      /**
       * STICKY MENU
       **/
      $(window).on("scroll", navbarSticky);

      navbarSticky();

      /**
       * SCROLLING NAVIGATION
       * Enable smooth transition animation when scrolling
       **/
      $('a.scrollto').on('click', function (event) {
        event.preventDefault();

        var scrollAnimationTime = 1200;
        var target = this.hash;

        $('html, body').stop().animate({
          scrollTop: $(target).offset().top - 45
        }, scrollAnimationTime, 'easeInOutExpo', function () {
          window.location.hash = target;
        });
      });

      /**
       *  NAVBAR SIDE COLLAPSIBLE - On Mobiles
       **/
      $(".navbar-toggler", $navbar).on("click", function () {

        if (!$navbar.is('.st-nav')) {
          $navbar.toggleClass("navbar-expanded");

        } else {

        }
      });

      /**
       * Blog interaction with buttons: favorite and bookmark
       **/
      $('.card-blog').on({
        click: function (e) {
          e.preventDefault();

          var $el = $(this).removeClass('far').addClass('fas');
          if ($el.hasClass('favorite')) {
            $el.addClass('text-danger');
          } else {
            $el.addClass('text-warning');
          }
        },
        mouseenter: function () {
          $(this).addClass('fas');
        },
        mouseleave: function () {
          $(this).removeClass('fas');
        }
      }, 'i.far');









      var $menuTab = $(".st-nav-section");


      $(".navbar-toggler").on("click", function () {
        $navbar.toggleClass("navbar-expanded");


        if ($navbar.is('.navbar-expanded')) {
          $menuTab.addClass("st-popup-active");
        } else {
          $menuTab.removeClass("st-popup-active");
        }
      });

      $(".st-dropdown-content-group").on("click", function () {
        $navbar.toggleClass("navbar-expanded");
        if ($navbar.is('.navbar-expanded')) {
          $menuTab.addClass("st-popup-active");
        } else {
          $menuTab.removeClass("st-popup-active");
        }
      });


      $(".st-popup-close-button").on("click", function () {
        $navbar.toggleClass("navbar-expanded");


        if ($navbar.is('.navbar-expanded')) {
          $menuTab.addClass("st-popup-active");
        } else {
          $menuTab.removeClass("st-popup-active");
        }
      });





    });





  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts